// Brand catalog: logos are saved locally in /public/brands/{slug}.png (downloaded once via scripts/fetch-brand-logos.sh)
const B = (slug, name, domain, models) => ({ slug, name, domain, models });

export const BRANDS = {
  appliance: [
    B("samsung", "Samsung", "samsung.com", ["Bespoke AI", "EcoBubble WW90", "RB38 Réfrigérateur combiné", "AddWash"]),
    B("lg", "LG", "lg.com", ["InstaView GSXV90", "F4V5 TurboWash", "QuadWash DF425"]),
    B("bosch", "Bosch", "bosch-home.fr", ["Série 4 WAN28", "Série 6 KGN39", "Série 8 SMV8", "Serie 2 SMS2"]),
    B("whirlpool", "Whirlpool", "whirlpool.fr", ["FreshCare+ FFB", "W Collection", "Supreme Clean"]),
    B("miele", "Miele", "miele.fr", ["WWD 320", "G 7000", "KFN 4795"]),
    B("electrolux", "Electrolux", "electrolux.fr", ["PerfectCare 700", "ComfortLift", "UltimateTaste"]),
    B("beko", "Beko", "beko.com", ["SteamCure WUE", "HarvestFresh", "AquaIntense"]),
    B("siemens", "Siemens", "siemens-home.bsh-group.com", ["iQ500", "iQ700", "iQ300"]),
    B("haier", "Haier", "haier.fr", ["I-Pro Series 7", "Cube 90", "FD 83"]),
    B("dyson", "Dyson", "dyson.fr", ["V15 Detect", "Gen5detect", "V8"]),
    B("delonghi", "De'Longhi", "delonghi.com", ["Magnifica S", "Dinamica Plus", "Eletta Explore"]),
    B("nespresso", "Nespresso", "nespresso.com", ["Vertuo Next", "Essenza Mini", "Lattissima One"]),
  ],
  multimedia: [
    B("samsung", "Samsung", "samsung.com", ["Neo QLED QN90D", "The Frame", "Crystal UHD CU7000", "OLED S90D"]),
    B("lg", "LG", "lg.com", ["OLED evo C4", "OLED B4", "QNED 86"]),
    B("sony", "Sony", "sony.fr", ["Bravia 7", "Bravia XR A80L", "PlayStation 5", "WH-1000XM5"]),
    B("philips", "Philips", "philips.fr", ["Ambilight OLED 809", "The One PUS8", "Hue"]),
    B("tcl", "TCL", "tcl.com", ["C805 Mini LED", "P755", "C745"]),
    B("panasonic", "Panasonic", "panasonic.com", ["OLED MZ1500", "TX-55LX", "Lumix S5"]),
    B("apple", "Apple", "apple.com", ["Apple TV 4K", "HomePod", "AirPods Pro"]),
    B("sonos", "Sonos", "sonos.com", ["Arc", "Beam", "Era 100"]),
    B("nintendo", "Nintendo", "nintendo.com", ["Switch OLED", "Switch"]),
  ],
  computer: [
    B("apple", "Apple", "apple.com", ["MacBook Air M3", "MacBook Pro 14", "iMac 24", "iPad Air", "iPhone 16"]),
    B("hp", "HP", "hp.com", ["Pavilion 15", "EliteBook 840", "Envy x360", "LaserJet M110"]),
    B("dell", "Dell", "dell.com", ["XPS 13", "Inspiron 15", "Latitude 5440"]),
    B("lenovo", "Lenovo", "lenovo.com", ["ThinkPad X1 Carbon", "IdeaPad Slim 5", "Yoga 7"]),
    B("asus", "Asus", "asus.com", ["ZenBook 14", "VivoBook 15", "ROG Strix"]),
    B("acer", "Acer", "acer.com", ["Aspire 5", "Swift Go 14", "Nitro 5"]),
    B("microsoft", "Microsoft", "microsoft.com", ["Surface Laptop 7", "Surface Pro 11", "Xbox Series X"]),
    B("samsung", "Samsung", "samsung.com", ["Galaxy S24", "Galaxy Tab S9", "Galaxy Book4"]),
  ],
  vehicle: [
    B("renault", "Renault", "renault.fr", ["Clio V", "Mégane E-Tech", "Captur", "Scenic E-Tech"]),
    B("peugeot", "Peugeot", "peugeot.fr", ["208", "308", "2008", "3008"]),
    B("citroen", "Citroën", "citroen.fr", ["C3", "C4", "C5 Aircross"]),
    B("volkswagen", "Volkswagen", "volkswagen.fr", ["Golf 8", "Polo", "ID.3", "Tiguan"]),
    B("tesla", "Tesla", "tesla.com", ["Model 3", "Model Y"]),
    B("toyota", "Toyota", "toyota.fr", ["Yaris", "C-HR", "RAV4"]),
    B("dacia", "Dacia", "dacia.fr", ["Sandero", "Duster", "Spring"]),
  ],
  installation: [
    B("daikin", "Daikin", "daikin.fr", ["Perfera", "Emura", "Altherma 3"]),
    B("atlantic", "Atlantic", "atlantic.fr", ["Alféa Excellia", "Naema", "Explorer V4"]),
    B("saunierduval", "Saunier Duval", "saunierduval.fr", ["ThemaFast", "Genia Air"]),
    B("frisquet", "Frisquet", "frisquet.com", ["Prestige Condensation", "Hydromotrix"]),
    B("mitsubishi", "Mitsubishi Electric", "mitsubishielectric.com", ["MSZ-LN", "Ecodan"]),
  ],
  jewelry: [
    B("cartier", "Cartier", "cartier.com", []),
    B("rolex", "Rolex", "rolex.com", []),
    B("omega", "Omega", "omegawatches.com", []),
    B("pandora", "Pandora", "pandora.net", []),
  ],
  art: [],
  sport: [
    B("decathlon", "Decathlon", "decathlon.fr", []),
    B("peloton", "Peloton", "onepeloton.com", []),
  ],
  tools: [
    B("bosch", "Bosch", "bosch-home.fr", ["PSB 18 LI-2", "GSR 18V", "PST 700"]),
    B("makita", "Makita", "makita.fr", ["DHP482", "DTD153", "DUC254"]),
    B("dewalt", "DeWalt", "dewalt.fr", ["DCD796", "DCF887"]),
    B("ryobi", "Ryobi", "ryobitools.eu", ["R18PD3", "ONE+ RY18"]),
  ],
  furniture: [
    B("ikea", "IKEA", "ikea.com", ["KIVIK", "MALM", "BILLY", "PAX"]),
    B("maisonsdumonde", "Maisons du Monde", "maisonsdumonde.com", []),
    B("conforama", "Conforama", "conforama.fr", []),
  ],
};

export const allBrands = () => Object.values(BRANDS).flat().filter((b, i, a) => a.findIndex((x) => x.slug === b.slug) === i);
export const brandsFor = (category) => BRANDS[category] || allBrands();
export const findBrand = (category, name) => (name ? brandsFor(category).find((b) => b.name.toLowerCase() === String(name).toLowerCase()) : undefined);
